import { StyleSheet } from "@react-pdf/renderer";
import theme from "./PrintApplicationTheme";
import { Font } from "@react-pdf/renderer";
// import OpenSansBold from "../../assets/fonts/Open_Sans/OpenSans-Bold.ttf";
import OpenSansBold from "../../../../assets/fonts/Open_Sans/OpenSans-Bold.ttf";
import OpenSansRegular from "../../../../assets/fonts/Open_Sans/OpenSans-Regular.ttf";

Font.register({
  family: "Open Sans",
  fonts: [
    { src: OpenSansBold, fontWeight: "bold" },
    { src: OpenSansRegular, fontWeight: "normal" },
  ],
});

const PrintApplicationStyles = StyleSheet.create({
  page: {
    flexDirection: "column",
    backgroundColor: theme.colors.White,
    padding: 30,
    fontSize: 10,
    gap: 0,
    marginTop: 0,
    marginBottom: 0,
    justifyContent: "flex-start",
    alignItems: "left",
    break: "avoid",
    fontFamily: "Open Sans",
  },
  header: {
    fontFamily: "Open Sans",
    fontSize: 18,
    textAlign: "center",
    fontWeight: "bold",
    color: theme.colors.Brand1PenBlue,
    alignItems: "center",
    flexGrow: 1,
  },
  sectionheader: {
    fontFamily: "Open Sans",
    fontSize: 14,
    fontWeight: "bold",
    color: theme.colors.Brand1PenBlue,
    // flexGrow: 1,
    marginBottom: 5,
  },

  row: {
    flexDirection: "row", // Align items horizontally
    justifyContent: "space-between", // Push content to edges
    alignItems: "center", // Align items vertically in the center
    alignContent: "center",
    marginBottom: 10,
  },

  content: {
    marginBottom: 10,
    textAlign: "justify",
    fontSize: 10,
    wrap: false,
    fontFamily: "Open Sans",
  },
  subcontent: {
    fontFamily: "Open Sans",
    fontWeight: "bold",
    fontSize: 10,
    padding: 0, // Remove unnecessary padding
    marginTop: 5,
    marginBottom: 5, // Ensure consistent spacing between elements
    textAlign: "justify",
    color: theme.colors.Brand1PenBlue,
  },

  subheading: {
    fontFamily: "Open Sans",
    fontSize: 12,
    marginTop: 5,
    fontWeight: "bold",
    color: theme.colors.Brand1PenBlue,
    lineHeight: 1.5,
  },

  inputtable: {
    flexDirection: "column",
    margin: 0, // Eliminate extra margin
    padding: 0, // Remove unnecessary padding
    width: "100%",
  },
  table: {
    display: "table",
    width: "100%", // Ensure the table takes up the full width
    borderStyle: "solid",
    borderWidth: 1,
    borderColor: theme.colors.Brand4LavenderWeb,
    marginBottom: 10,
    marginTop: 10,
  },
  tableRow: {
    flexDirection: "row",
    marginBottom: 0, // Avoid spacing between rows
    borderBottomStyle: "solid",
    borderBottomWidth: 1,
    borderBottomColor: theme.colors.Brand4LavenderWeb,
  },
  tableHeader: {
    backgroundColor: theme.colors.Brand1PenBlue,
    flexDirection: "row",
    alignItems: "center",
    justifyContent: "center",
    padding: 5,
    color: theme.colors.White,
    fontWeight: "bold",
    fontSize: 10,
    textAlign: "center",
    height: "auto",
  },
  tableCell: {
    padding: 5, // Reduce padding
    fontSize: 10,
    width: "50%", // Explicit width for equal columns
    wordWrap: "wrap", // Enable word wrapping
    textAlign: "left",
    borderRightColor: theme.colors.Brand4LavenderWeb,
    borderRightWidth: 1,
  },
  lastCell: {
    borderRightWidth: 0, // Remove border from the last cell
  },

  image: {
    // width: 500,
    // height: 500,
  },

  labelCellHeader: {
    paddingTop: 25,
    fontSize: 10,
    fontFamily: "Open Sans",
    // color: theme.colors.Brand1PenBlue,
  },

  inputSection: {
    width: "100%",
    padding: 5,
  },
  inputRow: {
    flexDirection: "row", // Arrange items in a row
    alignItems: "center", // Vertically align items
    justifyContent: "flex-start", // Align items to the start
    marginBottom: 5, // Add spacing between rows
  },

  inputLabel: {
    flex: 1, // Label takes up a smaller portion
    fontSize: 10,
    paddingRight: 10, // Add spacing between label and box
    textAlign: "left",
    fontFamily: "Open Sans",
  },

  inputBox: {
    flex: 1, // Input box takes up a larger portion
    padding: 5,
    backgroundColor: theme.colors.GhostWhite, // Background color for visibility
    minHeight: 20, // Ensure minimum height for inputs
    width: "100%", // Ensure input box fills available space
  },
});

export default PrintApplicationStyles;
